import "./footer.css";

const Footer = () => {
  return (
    <footer className="text-center d-block">
      <span className="footer-span color-primary font-family-class">
        Designed and Built by Zabihullah Azadzoi
      </span>
    </footer>
  );
};

export default Footer;
